import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
      iconfont: 'md',
    },
    theme: {
      options: {
        customProperties: true,
      },
      themes: {
        light: {
          primary: '#5f1d9a',
          secondary: '#dd0b7e',
          background: "#f6f7fb",
          text: "#251433",
          menu: "#ffffff",
          menuhover: "#f6f7fb",
          menuborder: "#e8e9ee",
          overlay: "#eeeeee"
        },
        dark: {
          primary: '#5f1d9a',
          secondary: '#dd0b7e',
          background: "#000000",
          text: "#f9f9f9",
          menu: "#292929",
          menuhover: "#3a3a3a",
          menuborder: "#434343",
          overlay: "333333"
        },
      },
    },
  })
